import { InjectionToken } from '@angular/core';

import { Theme } from '../enums';

export const DEFAULT_THEME = new InjectionToken<Theme>('DEFAULT_THEME');
